import React, { PureComponent, Fragment } from 'react';
import { Button, Grid, Typography, Box, TextField } from '@material-ui/core';
import './onboarding.scss';

class OnboardingStep1 extends PureComponent {
  render() {
    const {
      onCLickNext,
      organizationName,
      domains,
      technologies,
      userName,
      onChange,
    } = this.props;
    return (
      <Fragment>
        <Typography variant="h4" className="heading">
          Welcome {userName}
        </Typography>
        <TextField
          id="outlined-name"
          label="Company Name"
          margin="normal"
          variant="outlined"
          value={organizationName}
          fullWidth
          disabled
        />
        <TextField
          id="outlined-name"
          name="domains"
          label="Domains"
          placeholder="Eg talent, Design, IT ..."
          margin="normal"
          variant="outlined"
          value={domains}
          onChange={onChange}
          fullWidth
        />
        <TextField
          id="outlined-name"
          name="technologies"
          label="Technologies you work on"
          placeholder="Eg Devops, Blockchain Etc"
          margin="normal"
          variant="outlined"
          value={technologies}
          onChange={onChange}
          fullWidth
        />
        <Grid container direction="row" justify="flex-end" alignItems="center">
          <Grid item xs={5}>
            <Box marginTop="20px">
              <Button
                variant="contained"
                color="primary"
                fullWidth
                size="large"
                onClick={onCLickNext(2)}
              >
                Next
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Fragment>
    );
  }
}

export default OnboardingStep1;
